import api from "./api";

export const getConcessionariesAll = async() => {
    const response = await api.get(`concessionarie/listAll`);
    return response.data;
};
